module.exports = __webpack_public_path__ + "static/img/sdql.4f00876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sdql.png
// module id = pz4D
// module chunks = 0